import { render, staticRenderFns } from "./release.vue?vue&type=template&id=5243e057&scoped=true"
import script from "./release.vue?vue&type=script&lang=js"
export * from "./release.vue?vue&type=script&lang=js"
import style0 from "./release.vue?vue&type=style&index=0&id=5243e057&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5243e057",
  null
  
)

export default component.exports